<style lang="less">
.canvas{
	canvas{
		width: 326px;
		height: 180px;
		background: #fff;
	}
}
</style>

<template>
	<!-- Main canvas -->
	<section class="canvas">
		<canvas :id="id" width="978" height="540"></canvas>
	</section>
</template>

<script>
var Vector2 = function(x, y) {
	this.x = x;
	this.y = y;
}
Vector2.prototype = {
	"length": function() {
		return Math.sqrt(this.x * this.x + this.y * this.y);
	},
	"normalize": function() {
		var inv = 1 / this.length();
		return new Vector2(this.x * inv, this.y * inv);
	},
	"add": function(v) {
		return new Vector2(this.x + v.x, this.y + v.y);
	},
	"multiply": function(f) {
		return new Vector2(this.x * f, this.y * f);
	},
	"dot": function(v) {
		return this.x * v.x + this.y * v.y;
	},
	"angle": function(v) {
		return Math.acos(this.dot(v) / (this.length() * v.length())) * 180 / Math.PI;
	}
};
	export default {
		data: function () {
			return {
				can: null,
				info: {
					width: 978,
					height: 540
				},
				char: {
					axis: {
						x: [],
						y: [],
						yText: []
					},
					line: [],
					point: {
						x: [],
						y: []
					},
					limit: {
						y: {
							max: 0,
							min: 0
						},
						x: {
							max: 0,
							min: 0
						},
						textHeight: 72
					}
				},
				sourceData: {},
			};
		},
		components: {
		},
		props: {
			id: {
				type: String,
				default: 'char'
			},
			charData: {
				type: Object,
				required: true
			}
		},
		mounted: function () {
		},
		methods: {
			initCanvas: function () {
				this.canv = document.getElementById(this.id);
				this.canv.width = this.info.width;
				this.canv.height = this.info.height;

				if (this.sourceData.y) {
					this.getData();
				}
			},
			getData: function () {
				var data = this.sourceData;
				var max = data.y[0];
				var min = data.y[0];
				for(var i in data.y){
					if (data.y[i] > max) {
						max = data.y[i];
					}
					if (data.y[i] <= min) {
						min = data.y[i];
					}
				}
				this.char.limit.y.max = max;
				this.char.limit.y.min = min;
				this.char.limit.x.max = data.x.length > 2 ? data.x.length : 3;

				var differ = Math.round((max - min) * 100000) / 100000;
				var step = differ * 1.05;
				var pointParam = 100;

				if (differ < 0.01) {
					pointParam = 1000;
				}
				if (differ < 0.001) {
					pointParam = 10000;
				}

				step = Math.round(step * pointParam) / pointParam;

				if (differ === 0) {
					for( var n = -4; n <= 3; n++){
						this.char.axis.yText.push( Math.round((min + (n-1) * step)* pointParam)/ pointParam );
					}
				}else{
					var maxLix = Math.ceil(differ / step);
					if (Math.round((min + maxLix * step)* pointParam)/ pointParam - step/2 < max) {
						maxLix++;
					}
					for( var p = -3; p <= maxLix; p++){
						this.char.axis.yText.push( Math.round((min + p * step)* pointParam)/ pointParam );
					}
				}


				var yNumberLength = 0;
				for(var m in this.char.axis.yText){
					if (yNumberLength < (this.char.axis.yText[m] + '').length) {
						yNumberLength = (this.char.axis.yText[m] + '').length;
					}
				}
				for(var o in this.char.axis.yText){
					var ys = (this.char.axis.yText[o] + '').length - yNumberLength;
					if ( ys !== 0 ) {
						if ((this.char.axis.yText[o] + '').indexOf('.') !== -1) {
							this.char.axis.yText[o] = (this.char.axis.yText[o] + '000000000').substr(0, yNumberLength);
						} else {
							this.char.axis.yText[o] = (this.char.axis.yText[o] + '.' + '00000000').substr(0, yNumberLength);
						}
					}
				}

				this.buildRound();
				this.buildLine();
				this.buildAxisText();
				this.buildAxisYLine();
				this.shadow();

				var li = this.char.line.length - 1;
				this.buildTag(li, this.char.line[li]);
			},
			buildLine: function () {
				var data = this.sourceData.y;
				var ctx = this.canv.getContext("2d");
				ctx.globalCompositeOperation='destination-over';

				ctx.lineWidth = 6;
				ctx.fillStyle = '#999';
				ctx.strokeStyle = '#3D589D';
				ctx.lineJoin="round";
				ctx.setLineDash([]);

				ctx.beginPath();

				var linePoints = [];
				for( var i = 0; i < data.length; i++){
					var point = this.coordinate(i, data[i]);
					linePoints.push(point);
				}

				this.char.line = linePoints;

				// ctx.moveTo(linePoints[0].x, linePoints[0].y);
				for(var n = 0; n < linePoints.length - 1; n++) {
					ctx.moveTo(linePoints[n].x, linePoints[n].y);
					// ctx.bezierCurveTo(linePoints[n].x + 100, linePoints[n].y + (linePoints[n+1].y - linePoints[n].y)/4, linePoints[n+1].x -100, linePoints[n+1].y - (linePoints[n+1].y - linePoints[n].y)/3, linePoints[n+1].x, linePoints[n+1].y);
					var cp1 = {
						x: linePoints[n].x + (linePoints[n + 1].x - linePoints[n].x) / 2,
						y: linePoints[n].y + (linePoints[n + 1].y - linePoints[n].y) / 8
					};
					var cp2 = {
						x: linePoints[n + 1].x - (linePoints[n + 1].x - linePoints[n].x) / 2,
						y: linePoints[n + 1].y - (linePoints[n + 1].y - linePoints[n].y) / 8
					};
					ctx.bezierCurveTo(cp1.x, cp1.y, cp2.x, cp2.y, linePoints[n+1].x, linePoints[n+1].y);
					// var cp = this.bezierCurvePos(n);
					// ctx.bezierCurveTo(cp.before.x, cp.before.y, cp.before.x, cp.before.y, linePoints[n+1].x, linePoints[n+1].y);
				}

				ctx.stroke();
			},
			buildAxisText: function () {
				var data = this.sourceData.x;
				var ctx = this.canv.getContext("2d");

				ctx.font="30px Flyme";
				ctx.lineWidth = 6;
				ctx.fillStyle = '#999';
				ctx.strokeStyle = '#3D589D';
				ctx.lineJoin="round";
				ctx.textAlign="start";

				for( var i = 0; i < data.length; i++){
					var point = this.coordinate(i, this.char.axis.yText[0]);
					ctx.fillText(data[i], point.x - 30, point.y + this.char.limit.textHeight - 12, 120);
				}
				ctx.textAlign="end";
				for( var n = 0; n < this.char.axis.yText.length; n++){
					var yp = this.coordinate(0, this.char.axis.yText[n]);
					ctx.fillText(this.char.axis.yText[n], yp.x - 20, yp.y + 10, 120);
					this.buildAxisYLine(yp.x - 10, yp.y);
				}
			},
			buildAxisYLine: function (x, y) {
				var ctx = this.canv.getContext("2d");

				ctx.strokeStyle = '#ccc';
				ctx.lineWidth = 2;
				ctx.setLineDash([8,8]);

				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + this.info.width, y);
				ctx.stroke();
			},
			buildRound: function () {
				var data = this.sourceData.y;
				var ctx = this.canv.getContext("2d");
				ctx.globalCompositeOperation='destination-over';
				ctx.beginPath();
				ctx.setLineDash([]);

				for( var i = 0; i < data.length; i++){
					var point = this.coordinate(i, data[i]);
					ctx.moveTo(point.x + 10, point.y);
					ctx.arc(point.x, point.y, 10, 0, 2*Math.PI);
					ctx.closePath();
				}

				ctx.lineWidth = 3;
				ctx.strokeStyle = '#fff';
				ctx.fillStyle="#2e4276";

				ctx.fill();
				ctx.stroke();
			},
			shadow: function () {
				var ctx = this.canv.getContext("2d");
				var linePoints = this.char.line;

				ctx.beginPath();

				ctx.moveTo(linePoints[0].x, linePoints[0].y);
				for(var n = 0; n < linePoints.length - 1; n++) {
					// ctx.bezierCurveTo(linePoints[n].x + 100, linePoints[n].y + (linePoints[n+1].y - linePoints[n].y)/4, linePoints[n+1].x -100, linePoints[n+1].y - (linePoints[n+1].y - linePoints[n].y)/3, linePoints[n+1].x, linePoints[n+1].y);
					var cp1 = {
						x: linePoints[n].x + (linePoints[n + 1].x - linePoints[n].x) / 2,
						y: linePoints[n].y + (linePoints[n + 1].y - linePoints[n].y) / 8
					};
					var cp2 = {
						x: linePoints[n + 1].x - (linePoints[n + 1].x - linePoints[n].x) / 2,
						y: linePoints[n + 1].y - (linePoints[n + 1].y - linePoints[n].y) / 8
					};
					ctx.bezierCurveTo(cp1.x, cp1.y, cp2.x, cp2.y, linePoints[n+1].x, linePoints[n+1].y);
				}

				var maxPos = this.coordinate(this.sourceData.y.length - 1, this.char.limit.y.max);
				var minPos = this.coordinate(0, this.char.limit.y.min);

				var yp = this.coordinate(0, this.char.axis.yText[0]);
				ctx.lineTo(maxPos.x, yp.y - 10);
				ctx.lineTo(minPos.x, yp.y - 10);

				ctx.closePath();

				var shadowStyle = ctx.createLinearGradient(0, maxPos.y, 0, minPos.y + 200);
					shadowStyle.addColorStop(0.2, 'rgba(74, 105, 186, 0.3)');
					shadowStyle.addColorStop(1, 'rgba(255, 255, 255, 0)');

				ctx.globalCompositeOperation="source-over";

				ctx.fillStyle = shadowStyle;
				ctx.fill();


			},
			buildTag: function (i, pos) {
				var ctx = this.canv.getContext("2d");
				// var linePoints = this.char.line;
				var start = {
					x: pos.x,
					y: pos.y - 25
				};

				var str = this.sourceData.y[i] + '%';

				ctx.beginPath();

				ctx.font="36px Flyme";

				var arrow = 10,
					tW = ctx.measureText(str).width / 2 + 8,
					tH = 48;

				ctx.moveTo(start.x, start.y + arrow);
				ctx.lineTo(start.x + arrow , start.y);
				ctx.lineTo(start.x + tW, start.y);
				ctx.lineTo(start.x + tW, start.y - tH);
				ctx.lineTo(start.x - tW, start.y - tH);
				ctx.lineTo(start.x - tW, start.y);
				ctx.lineTo(start.x - arrow, start.y);
				ctx.closePath();

				ctx.fillStyle="#dc2a2a";
				ctx.fill();

				ctx.fillStyle="#fff";
				ctx.textAlign="center";
				ctx.fillText(str, start.x, start.y - 12, 2 * tW);
			},
			coordinate: function (x, y) {
				var textHeight = this.char.limit.textHeight;
				if (x !== undefined && y !== undefined) {
					return {
						x: ((this.info.width - textHeight / 2) * x) / this.char.limit.x.max + textHeight * 1.5,
						// y: Math.round(this.info.height - ((this.info.height - textHeight) * y) / this.char.axis.yText[this.char.axis.yText.length - 1]),
						y: Math.round(this.info.height - ((this.info.height - textHeight * 2) * (y - this.char.axis.yText[0])) / ((this.char.axis.yText[this.char.axis.yText.length - 1]) - this.char.axis.yText[0]) ) - textHeight
					};
				}
				if (x !== undefined) {
					return x + textHeight;
				}
				if (y !== undefined) {
					return this.info - textHeight;
				}
			},
			bezierCurvePos: function (index) {
				var linePoints = this.char.line;

				var a = linePoints[index],
					b = linePoints[index + 1],
					c = linePoints[index + 2];

				var rt = 0.3;

				var v1 = new Vector2(a.x - b.x, a.y - b.y);
				var v2 = new Vector2(c.x - b.x, c.y - b.y);

				var v1Len = v1.length(),
					v2Len = v2.length();

				var centerV = v1.normalize().add(v2.normalize()).normalize();

				var ncp1 = new Vector2(centerV.y, centerV.x * -1);
				var ncp2 = new Vector2(centerV.y * -1, centerV.x);

				var p1 = null,
					p2 = null;
				if (ncp1.angle(v1) < 90) {
					p1 = ncp1.multiply(v1Len * rt).add(b);
					p2 = ncp2.multiply(v2Len * rt).add(b);
				} else {
					p1 = ncp1.multiply(v2Len * rt).add(b);
					p2 = ncp2.multiply(v1Len * rt).add(b);
				}
				return {
					before: p1,
					after: p2
				};
			},
			vector2d: function (x, y) {
				var vec = {
					vx: x,
					vy: y,
					// 缩放
					scale: function(scale) {
						vec.vx *= scale;
						vec.vy *= scale;
					},
					//加 另一个向量
					add: function(vec2) {
						vec.vx += vec2.vx;
						vec.vy += vec2.vy;
					},
					//减 另一个向量
					sub: function(vec2) {
						vec.vx -= vec2.vx;
						vec.vy -= vec2.vy;
					},
					//相反方向
					negate: function() {
						vec.vx = -vec.vx;
						vec.vy = -vec.vy;
					},
					//向量长度
					length: function() {
						return Math.sqrt(vec.vx * vec.vx + vec.vy * vec.vy);
					},
					//向量长度的平方
					lengthSquared: function() {
						return vec.vx * vec.vx + vec.vy * vec.vy;
					},
					//标准化
					normalize: function() {
						var len = Math.sqrt(vec.vx * vec.vx + vec.vy * vec.vy);
						if (len) {
							vec.vx /= len;
							vec.vy /= len;
						}
						return len;
					},
					//旋转
					rotate: function(angle) {
						var vx = vec.vx,
							vy = vec.vy,
							cosVal = Math.cos(angle),
							sinVal = Math.sin(angle);
						vec.vx = vx * cosVal - vy * sinVal;
						vec.vy = vx * sinVal + vy * cosVal;
					},
					//调试
					toString: function() {
						return '(' + vec.vx.toFixed(3) + ',' + vec.vy.toFixed(3) + ')';
					}
				};
				return vec;
			},
			clear: function () {
				var ctx = this.canv.getContext("2d");
				ctx.clearRect(0, 0, this.info.width, this.info.height);
			},
			save: function () {
				var ctx = this.canv.getContext("2d");
				ctx.save();
			},
			restore: function () {
				var ctx = this.canv.getContext("2d");
				ctx.restore();
			},
			eventListen: function () {
				var linePoints = this.char.line,
					touchWidth = 45;
				let _this = this;

				touchWidth = parseInt((linePoints[1].x - linePoints[0].x) * 3 / 4);

				function refreash(i) {
					_this.clear();
					_this.buildRound();
					_this.buildLine();
					_this.buildAxisText();
					_this.buildAxisYLine();
					_this.shadow();
					_this.buildTag(i, linePoints[i]);
					return;
				}

				document.getElementById(this.id).addEventListener('click', function(e){
					// let [x, y] = [e.offsetX * 3, e.offsetY * 3];
					let x = e.offsetX * 3;
					for( var i in linePoints){
						if (linePoints[i].x - touchWidth < x && x < linePoints[i].x + touchWidth) {
							// if (linePoints[i].y - touchWidth < y && y < linePoints[i].y + touchWidth) {
								refreash(i);
							// }
						}
					}
				});
				document.getElementById(this.id).addEventListener('touchmove', function(e){
					// console.log(e);
					// let [x, y] = [e.offsetX * 3, e.offsetY * 3];
					let x = e.touches[0].clientX * 3;
					for( var i in linePoints){
						if (linePoints[i].x - touchWidth < x && x < linePoints[i].x + touchWidth) {
							// if (linePoints[i].y - touchWidth < y && y < linePoints[i].y + touchWidth) {
								refreash(i);
							// }
						}
					}
				});
			}
		},
		watch: {
			charData: {
				handler: function (n) {
					if (n.x.length > 0 && n.y.length > 0) {
						document.getElementById(this.id).getContext("2d").clearRect(0, 0, this.info.width, this.info.height);
						this.sourceData = n;

						this.char = {
							axis: {
								x: [],
								y: [],
								yText: []
							},
							point: {
								x: [],
								y: []
							},
							limit: {
								y: {
									max: 0,
									min: 0
								},
								x: {
									max: 0,
									min: 0
								},
								textHeight: 72
							}
						};

						this.initCanvas();
						document.getElementById(this.id).removeEventListener('click', function () {

						});
						this.eventListen();
					}
				},
				deep: true
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/char_2.vue